import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { HeaderService } from './header.service';
import { Observable } from 'rxjs';
import { EnvironmentModel } from '@zp-shared/models/environment.model';

/**
 * Service for handling HTTP routing and requests.
 * Provides methods for GET, POST, PUT, and DELETE operations with URL parameter replacement.
 */
@Injectable({
  providedIn: 'root',
})
export class HttpRoutingService {
  /**
   * To store headerService details
   */
  headerService: HeaderService = inject(HeaderService);
  /**
   * contructor
   * @param httpClient 
   * @param environment 
   */
  constructor(private httpClient: HttpClient, @Inject('environment') private environment: EnvironmentModel) { }
  /**
* Method which is used to replace url params.
* @param url To get url.
* @param obj To get params object.
* @returns returns replaced url.
*/
  replaceUrlParam(url: any, obj: any) {
    for (const key in obj) {
      const replaceText = '{' + key + '}';
      url = url.replace(replaceText, obj[key]);
    }
    return url;
  }
  /**
 * Method Which is used to send the get api request to the server
 * @param url Define api request url
 * @param queryParams Defines the other optional parameters.
 */
  getMethod(url: string, queryParams?: any) {
    if (!queryParams) {
      queryParams = {};
    }
    const apiUrl = this.environment.apiUrlDb + url;
    return this.httpClient.get(apiUrl, {
      params: queryParams
    });
  }
  /**
   * Method Which is used to send the post api request to the server
   * @param url Define api request url
   * @param data Define the data
   * @param queryParams Defines the other optional parameters
   */
  postMethod(url: string, data: any, queryParams?: any): Observable<any> {
    const apiUrl = this.environment?.apiUrlDb + url;
    return this.httpClient.post(apiUrl, data, {
      params: queryParams,
    });
  }
  /**
* Method putMethod Which is used to send the put api request to the server.
* @param url Define api request url.
* @param data Define the data.
* @param queryParams Defines the other optional parameters.
*/
  putMethod(url: string, data: any, queryParams?: any) {
    const apiUrl = this.environment.apiUrlDb + url;
    return this.httpClient.put(apiUrl, data, {
      params: queryParams,
    });
  }
  /**
   * Method deleteMethod Which is used to send the delete api request to the server.
   * @param url Define api request url.
   */
  deleteMethod(url: string, queryParams?: any) {
    const apiUrl = this.environment.apiUrlDb + url;
    return this.httpClient.delete(apiUrl, { params: queryParams });
  }

}